<template>
	<v-main>
        <v-container>
            <!-- <v-toolbar elevation="0">
				<v-btn icon color="primary" @click="$router.push('/')">
					<v-icon>mdi-home</v-icon>
				</v-btn>
				<v-toolbar-title class="font-weight-light">{{ $vuetify.lang.t('$vuetify.' + title) | capitalize }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar> -->

			<v-data-table
				v-model="selected"
				:headers="headers"
				:items="items"
				item-key="id"
				
				:loading="loading"
				:search="searchText"
				loading-text="Завантаження даних... зачекайте, будь ласка." 
			>
			<!-- show-select -->

			<!-- :items-per-page="-1"
				hide-default-footer -->
				<template v-slot:top>
					<v-toolbar flat>
						<v-app-bar-nav-icon>
							<v-icon>{{ icon }}</v-icon>
						</v-app-bar-nav-icon>
						<v-toolbar-title>{{ $vuetify.lang.t(`$vuetify.${title}`) | capitalize }}</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-spacer></v-spacer>
						<v-text-field
							v-model="searchText"
							append-icon="mdi-magnify"
							label="Пошук"
							dense
							single-line
							hide-details
							outlined
							rounded
						></v-text-field>
						<!-- Оновити -->
						<v-btn icon @click="onRefresh">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
					</v-toolbar>
				</template>

				
				<template v-slot:[`item.active`]="{ item }">
					<v-tooltip bottom v-if="item.active">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="success">mdi-circle</v-icon>
						</template>
						<span>{{ item.dateactive | formatDateTime }}</span>
					</v-tooltip>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<v-toolbar flat dense color="transparent">
						<!-- <z-detail v-model="item" @update="edit(item, $event)">
							<template v-slot:activator="props">
								<v-icon class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">mdi-pencil</v-icon>
							</template>
						</z-detail> -->
						<v-menu offset-y ref="menu">
							<template v-slot:activator="{ on, attrs }">
								<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
							</template>
							<v-list>
								<z-detail
									v-model="item"
									:selected="item"
									@update="edit(item, $event)"
								>
									<template v-slot:activator="props">
										<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-list-item-icon>
												<v-icon>mdi-pencil</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Редагувати</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</z-detail>

								<!-- <z-detail v-if="permitionUpdate"
									:selected="item"
									@close="onClose"
									@update="edit(item, $event)"
								>
									<template v-slot:activator="props">
										<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-list-item-icon>
												<v-icon>mdi-pencil</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Редагувати</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</z-detail> -->

								<!-- <z-dialog-estimate :park="item">
									<template v-slot:activator="props">
										<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-list-item-icon>
												<v-icon>mdi-ruler-square-compass</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Створити оцінку</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</z-dialog-estimate> -->

								<!-- <v-list-item>
									<v-list-item-icon>
										<v-icon>mdi-ruler-square-compass</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Оцінка</v-list-item-title>
									</v-list-item-content>
								</v-list-item> -->

								<v-divider></v-divider>

								<z-confirm-delete @ok="onDelete(item)" activator-type="list-item"></z-confirm-delete>
							</v-list>
						</v-menu>
					</v-toolbar>
				</template>
			</v-data-table>

			
		</v-container>

		<z-detail tooltip="create" @create="add">
			<template v-slot:activator="props">
				<v-fab-transition>
					<v-btn
						v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}"
						color="primary"
						dark
						fixed
						bottom
						right
						fab
						class="mb-8 mr-8"
						@create="add"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-fab-transition>
			</template>
		</z-detail>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<!-- <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar> -->
    </v-main>
</template>

<script>
import axios from 'axios'
//import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
//import downloadExcel from "vue-json-excel"
//import zDetail from '@/views/dialogs/details/VehiclePark'
import zDetail from '@/views/dialogs/details/Fleet'
//import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'Fleet',
	//mixins: [mixin],
	components: {
		//downloadExcel,
		zDetail,
		zConfirmDelete,
	},
	data: () => ({
		title: 'parks',
		subtitle: 'Реєстр медикаментів та лікарських форм',
		icon: 'mdi-car-2-plus',
		color: 'green darken-1',
		searchText: '',
		loading: false,

		//search: null,

		selected: [],

		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			//{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true},
			{ text: 'Авто', value: 'objects.length', sortable: true},
			//{ text: 'Оцінки', value: 'estimates.length', sortable: true},
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		page: 1,
		pageCount: 2,
		itemsPerPage: 15,

		/* snackbar: {
			visible: false,
			text: null
		}, */
	}),
	
	computed: {
		...mapGetters('Fleet', [ 'items' ]),
	},

	mounted() {
		this.onRefresh()
	},

	methods: {
		...mapActions(['showMessage']),
		...mapActions('Fleet', [ 'search', 'delete' ]),

		/* search() {
			let that = this
			this.loading = true
			return axios.get('/fleet', { params: params}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading = false));
		}, */

		add(data) {
			//console.log(this.$options.name, 'add', 'data', data)
			this.items.push(data)
		},

		edit(item, data) {
			//console.log(this.$options.name, 'edit', 'item', item)
			//console.log(this.$options.name, 'edit', 'data', data)
			
			const index = this.items.indexOf(item)
			this.items.splice(index, 1, data)
		},

		remove(item, data) {
			/* const index = this.items.indexOf(item)
			this.items.splice(index, 1, data) */
		},

		onRefresh() {
			this.loading = true
			return this.search().finally(() => (this.loading = false));
		},

		/* onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			this.selected = [];

			//Формування параметрів
			let params = { search: this.search }

			//Спроба перетворити рядок на масив
			const arr = this.search.split(/[ ,;\t]+/).map(Number);
			if(Array.isArray(arr)) {
				// Перевірка чи всі елементи масиву є цілими числами 
				if(arr.every(Number.isInteger)) {
					// Якщо так, то це перелік кодів Моріон
					params = { idMorion: arr }
				}
			}
		}, */
	},
}
</script>